import { Injectable } from '@angular/core';
import {RequestOptions, Http, RequestOptionsArgs} from '@angular/http';
import * as Rx from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class HttpService {
    constructor(public http: Http) { }

    private getRequestOptions(search = null): RequestOptions {
        return new RequestOptions({search});
    }

    public post(url: string, data, headers?: Headers): Rx.Observable<any> {
        let options = this.getRequestOptions(headers);

        return this.http.post(url, data, options).map(res => res.json());
    }

    public put(url: string, data, headers?: Headers): Rx.Observable<any> {
        let options = this.getRequestOptions(headers);

        return this.http.put(url, data, options).map(res => res.json());
    }

    public get(url: string, search?: string | URLSearchParams | {[key: string]: any | any[];} | null): Rx.Observable<any> {
        let options = this.getRequestOptions(search);

        return this.http.get(url, options).map(res => res.json());
    }

    public delete(url: string, headers?): Rx.Observable<any> {
        let options = this.getRequestOptions(headers);

        return this.http.delete(url, options).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/services/http.service.ts